// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Account Type'),
    name: 'accountTypes',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Asset'), value: 'ASSET' },
      { label: i18n.t('Liability'), value: 'LIABILITY' },
      { label: i18n.t('Equity'), value: 'EQUITY' },
      { label: i18n.t('Revenue'), value: 'REVENUE' },
      { label: i18n.t('COGS'), value: 'COGS' },
      { label: i18n.t('Expense'), value: 'EXPENSE' },
    ],
  },
  {
    label: i18n.t('Status'),
    name: 'isActive',
    type: 'select',
    selectOptions: [
      { label: i18n.t('Active'), value: 'true' },
      { label: i18n.t('Inactive'), value: 'false' },
    ],
  },
];
